import React from 'react';

import Avatar from 'Components/Member/Avatar';
import Listing from 'Components/Core/Listing';
import './MemberList.css';

export default function MemberListBasis(props) {

    const x = props.x;

	const renderCount = React.useRef(0);
	const active = (typeof props.active === 'undefined') ? 0 : props.active;

	let orderField = (typeof props.orderField === 'undefined') ? '' : '&order-field=' + props.orderField;
	var lf;
	var memberList;
	var onlineCount;
	// var memberCount = 0;

	React.useEffect(() => {
		renderCount.current++;
		if (renderCount.current === 1) {
			loadMemberList();
		}
	});

	x.wab.init(props.id, {
	});

	x.was.loadActiveMember = loadMemberList;
	x.was.makeMemberList = makeMemberList;

	function registerListing(listingFunctions) {
		lf = listingFunctions;
	}

	async function loadMemberList() {
		// const url = 'Backend/webapp.php?module=Member&task=MemberList&active=1' + ((orderField === '') ? '' : '&order-field=' + orderField);
		// x.was.axGet(url, handleLoadMemberList);
		const result = await x.was.getMemberList(orderField);
		if (result !== false && result.data['returncode'] === 1) {
			// console.log(result.data.buildno);
			if (result.data.buildno > x.was.buildNo) {
				x.was.loadSoftwareUpdate();
			}
			else {
				memberList = result.data['content'];
				makeMemberList();
				clearTimeout(x.was.loadMemberListTimeOut);
				// x.was.loadMemberListTimeOut = setTimeout(() => loadMemberList('Timeout'), 30000);
				addNewMessageHint();
			}
		}
	}

	function addNewMessageHint() {
		if (Object.keys(x.was.postingsUnread).length > 1) {
			let conversationalPartner;
			Object.entries(x.was.postingsUnread).forEach(([key, value]) => {
				if (key !== 'forum') {
					conversationalPartner = x.wau.getConversationalPartner(key);
					// x.wah.addHint(args.hint);
					if (typeof x.was.postingsUnreadHint[conversationalPartner] !== 'undefined' && x.wah.isVisible(x.was.postingsUnreadHint[conversationalPartner])) {
						x.wah.removeHint(null, x.was.postingsUnreadHint[conversationalPartner]);
						x.was.postingsLastUnread[key] = 0;
					}
					if (typeof x.was.postingsLastUnread[key] === 'undefined' || x.was.postingsUnread[key] > x.was.postingsLastUnread[key]) {
						const hint = ((x.was.postingsUnread[key] > 1) ? 'Sie haben ' + x.was.postingsUnread[key] + ' neue Privatnachrichten von ' : 'Sie haben eine neue Privatnachricht von ') + x.was.members[conversationalPartner].name + '!';
						x.was.postingsUnreadHint[conversationalPartner] = x.wah.addHint(hint, false, 'Lesen', () => x.wam.openPrivateForum(conversationalPartner, x.was.members[conversationalPartner].name, x.was.members[conversationalPartner].level));
						x.was.postingsLastUnread[key] = x.was.postingsUnread[key];
					}
				}
			});
		}
	}

	function makeMemberList(updatePostingsUnread = true) {
		lf.reset();
		x.was.postingsUnread = { 'forum': x.was.postingsUnread.forum };				// Alle Member-Foren löschen 
		onlineCount = 0;
		x.was.members = {}
		if (memberList) {

			memberList.forEach(
				function (item) {
					if (updatePostingsUnread && item.postingsunread > 0) {
						x.was.postingsUnread[item.forumid] = item.postingsunread;
					}
					addRow(item);
					x.was.members[item.memberid] = { 
						'name': item.membername, 
						'level': item.memberlevel, 
						'avatar': item.avatartext,
						'avatarimage': item.avatarimage 
					};
					if (item.memberid === x.was.memberId) {
						x.was.avatarimage = item.avatarimage;
					}
				}
			)
		}

		addHeader();			// muss nach den Rows erzeugt werden, da in der Funktion addRow die Variable onlineCount hochgezählt wird
		// addFooter();

		lf.makeListing();
		x.was.updatePostingsUnread();
	}

	function sortMemberList(event, sortField) {
		event.preventDefault();
		orderField = sortField;
		loadMemberList();
	}

	function addHeader() {
		if (active) {
			let tagOnlineCount =
				<span className='online-count'>
					{'Online: ' + onlineCount}
				</span>
			// let tagHome = <i className="bi bi-house app-icon" title="Startseite anzeigen" onClick={activateHome}></i>
			// let tagSetHome = <i className="bi bi-house-check app-icon" title="Aktuelles Modul als Startseite festlegen" onClick={e => x.wam.activate('forum')}></i>
			let tagAvatar =
				<span onClick={e => x.wam.activate('settings')}>
					<Avatar memberLevel={x.was.memberLevel} avatarText={x.was.memberName} image={x.was.avatarimage}>
					</Avatar>
				</span>;
			let header =
				<React.Fragment>
					{tagAvatar} 
					{tagOnlineCount}
					<i className="bi bi-box-arrow-right app-icon" title="Abmelden" onClick={e => x.was.logout()}></i>
				</React.Fragment>
			lf.addHeader(<span>{header}</span>);
		}
		else {
			lf.addHeader(<span className="anker" onClick={(e) => { sortMemberList(e, 'memberid') }}>{'ID'}</span>);
			lf.addHeader((<span className="anker" onClick={(e) => { sortMemberList(e, 'membername') }}>{'Pseudonym'}</span>));
			lf.addHeader((<span className="anker" onClick={(e) => { sortMemberList(e, 'm.lastlogin desc') }}>{'Letzte Anmeldung'}</span>));
			lf.addHeader(<span className="anker" onClick={(e) => { sortMemberList(e, 'm.lastrequest desc') }}>{'Letzter Zugriff'}</span>);
			lf.addHeader(<span className="anker" onClick={(e) => { sortMemberList(e, 'locked desc') }}>{'Gesperrt'}</span>);
			lf.addHeader(<span className="anker" onClick={(e) => { sortMemberList(e, 'postingcount desc') }}>{'Beiträge'}</span>);
		}
	}

	function rowClicked(e, raw) {
		e.preventDefault();
		if (x.wau.getAttribute(e, 'column-id', '') === 'avatar') {
			x.wam.openProfile(raw.memberid, raw.membername)	
		}
		else {
			x.wam.openPrivateForum(raw.memberid, raw.membername, raw.memberlevel);
		}
	}

	function addRow(item) {
		if (active) {
			onlineCount = onlineCount + ((item.online === 1) ? 1 : 0);
			let onlineIconClass = (item.online === 1) ? 'bi-circle-fill' : 'bi-circle';
			//			tagAvatar = <Avatar memberLevel={item.memberlevel} avatarText={item.avatartext} small />;
			let tagMemberName =
				<span className='avatar-list-name' title={'ID: ' + item.memberid}>
					<i className={` bi ${onlineIconClass} `} title="Online-Status" />
					<span className="member-name">{item.membername}</span>
				</span>
			let tagAvatar =
				<React.Fragment>
					<Avatar memberLevel={item.memberlevel} memberName={tagMemberName} avatarText={item.membername} size="small" image={item.avatarimage} />
				</React.Fragment>;
			const tagForum =
				<React.Fragment>
					<i className="bi bi-chat-square-text-fill no-user-forum-icon"></i>
					<span className="forum-name">{item.membername}</span>
				</React.Fragment>;
			let tagUnread =
				(item.forumid === 'forum') 
					?
					<React.Fragment>
						<span className={` unread-count ${(x.was.postingsUnread.forum === 0) ? "d-none" : ""} `} >{(x.was.postingsUnread.forum > 999) ? '++' : x.was.postingsUnread.forum}</span>
					</React.Fragment>
					:
					<React.Fragment>
						<span className={` unread-count ${(item.postingsunread === 0) ? "d-none" : ""} `} >{(item.postingsunread > 999) ? '++' : item.postingsunread}</span>
					</React.Fragment>

			let tagRow =
				<React.Fragment>
					{(item.ismember === 1) ? tagAvatar : tagForum}
					{tagUnread}
				</React.Fragment>;

			lf.addRow(
				[tagRow], 
				item,
				(item.ismember === 1) ? '' : 'listing-row-no-user-forum',
				(e, raw, column) => {
					e.preventDefault();
					if (raw.forumid === 'forum' || raw.forumid === 'admin') {
						x.wam.activate(raw.forumid);
					}
					else if (raw.ismember === 0) {
						x.wam.openForum(raw.forumid, raw.membername);
					}
					else {
						rowClicked(e, raw);
					}
				}
			);

		}
		else {
			if (item.ismember === 1) {
				let tagAvatar = 
					<Avatar 
						columnId="avatar"
						memberLevel={item.memberlevel} 
						memberName={item.membername} 
						avatarText={item.avatartext} 
						size="small" 
						image={item.avatarimage}
					/>;
				let tagLocked = (item.locked === 1) ? <i className="bi bi-check-circle"></i> : null;
				lf.addRow([
					item.memberid, 
					tagAvatar, 
					item.lastlogin, 
					item.lastrequest, 
					tagLocked, 
					item.postingcount], 
					item,
					'',
					(e, raw, column) => {
						rowClicked(e, raw);
					}
				);
			}
		}
	}

	return (
		<Listing id="member-listing" x={x} registerListing={registerListing} classes={`member-list ${props.classes}`} noTitle={false} />
	)


};

